<up-chat *ngIf="startupService.isStreamChatModuleEnabled()"
  [hideCreateChannels]="!startupService.allowCreateChatChannel()"
  (createNewChannel)="navigateToChannel($event)"
  (channelSelected)="navigateToChannel($event?.id)"
  (error)="chatError($event)" class="mt-2"></up-chat>
<div *ngIf="!startupService.isStreamChatModuleEnabled()">
  {{ 'StreamChatModuleDisabled' | translate }}
</div>
